import React from 'react'
import useDebounce from 'react-use/lib/useDebounce'
export const useDeBounceValue = (
  val,
  time = 300
) => {
  const [
    debouncedValue,
    setDebouncedValue
  ] = React.useState(val)
  useDebounce(
    () => {
      setDebouncedValue(val)
    },
    time,
    [val]
  )
  return debouncedValue
}
